var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSovosDefaultProductIconLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Default"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container",
    width: 120,
    height: 120,
    rx: 24,
    fill: "url(#paint0_linear_13460_66922)"
  }), /*#__PURE__*/React.createElement("g", {
    id: ".Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/sovos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4 29.2H29.2V90.4H90.4V29.2ZM85.0451 34.7463H34.7464V85.0451H85.0451V34.7463ZM60.3737 48.1337C55.4012 48.1337 53.2975 50.0462 53.2975 52.5324C53.2975 55.541 56.9129 56.395 60.9999 57.3604C66.2659 58.6042 72.3148 60.033 72.4225 66.4937C72.4225 71.6574 68.215 76.0562 59.4175 76.0562C55.4012 76.0562 51.5762 75.0999 48.7075 73.5699V67.6412C51.385 69.7449 55.4012 71.2749 59.4175 71.2749C64.39 71.2749 66.4937 69.3624 66.4937 67.0674C66.4937 64.1034 62.9493 63.2661 58.9122 62.3124C53.5715 61.0508 47.3687 59.5854 47.3687 52.7237C47.3687 47.5599 51.5762 43.1612 60.3737 43.1612C63.4337 43.1612 66.685 43.7349 69.1712 44.8824V50.6199C66.3025 48.8987 63.2425 48.1337 60.3737 48.1337Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13460_66922",
    x1: 60,
    y1: -60,
    x2: -60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013CB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSovosDefaultProductIconLarge);
export default __webpack_public_path__ + "static/media/Sovos-Default-Product-Icon-Large.8f21821f61795a152c8eb47cc733f41d.svg";
export { ForwardRef as ReactComponent };